var React = require('react');

function MendedHeartCroppedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M27.4 0 21 6.1 14.8 0H6.7L0 6.4v14.3l21 20.5 21.3-20.6V6.5L35.4 0h-8Zm.9 3.2h6.1l-5 11.2-6.3-6.2 5.2-5Zm-8.5 32.7-4.7-4.7 4.4-10.1 4.8 4.7-4.5 10.1Zm-2.6-17-4.4 10-5.4-5.2 7.3-7.3 2.5 2.5Zm8.4 4-9.1-9L19 8.2l9.1 9.1-2.5 5.6ZM7.8 3.2h6.1l2.9 2.9-2.5 5.6-7.7-7.3 1.2-1.2ZM3.3 7.8l1.1-1.1 8.1 7.7-7.2 7.2-2-1.9V7.8ZM39 19.6 23.8 34.1l6.5-14.6.7-1.5h8v1.6Zm0-4.9h-6.6l4.2-9.3L39 7.7v7Z","fill":"currentColor"}));
}

MendedHeartCroppedInline.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","clipRule":"evenodd","viewBox":"0 0 42.3 41.2"};

module.exports = MendedHeartCroppedInline;

MendedHeartCroppedInline.default = MendedHeartCroppedInline;
